import { Outlet, Link, useLoaderData, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Resizable } from "re-resizable";
import * as API from "../services/pacientes";
import * as APIUSER from "../services/user";
import { TratamientoList } from "./TratamientoList";
import { ReactComponent as Logo } from "../img/logo.svg";
import Navigation from '../components/Navigation';

export default function DashboardPaciente(props) {
  const paciente = props.currentUser;
  const metaTratamiento = paciente?.meta?.tratamientos;
  const location = useLocation();
  const [tratamientoList, setTratamientoList] = useState(<ul className='tratamiento-list'><li><a>Sin tratamientos</a></li></ul>);

  useEffect(() => {
    if (metaTratamiento && metaTratamiento?.length !== 0) {
      setTratamientoList(<TratamientoList list={metaTratamiento} especialistaId={props.especialistaId} userRole={props.userRole} pacienteName={paciente.name} />);
    }
  }, [metaTratamiento, props.especialistaId, props.userRole]);

  return (
    <>
      <Resizable
        id='sidebar'
        defaultSize={{
          width: 315,
        }}
        minHeight='100vh'
        maxHeight='100vh'
        className="open"
      >
        <div className='logo'>
          <Logo />
        </div>
        <h1>{paciente.name}</h1>

        <nav>
          {/* <ul className="tratamiento-list">
            <li><NavLink to={`datos`}>Datos Paciente</NavLink></li>
          </ul> */}
          {tratamientoList}
          <ul className="tratamiento-list">
            <li>
              <NavLink to={`creditos`}>Ganancias</NavLink>
            </li>
            <li>
              <NavLink to={`sueno`}>Asistente IA Sueño</NavLink>
            </li>
            
          </ul>
        </nav>
      </Resizable>
      <main id='main'>
        <Navigation {...props} currentUrl={location.pathname} />
        <div id='detail'>
          <Outlet />
        </div>
      </main>
    </>
  );
}
